import type { AxleListing } from '@contracts/axle/AxleListing';
import {
  AxleCapacityField,
  AxleGroupField,
  AxleIdField,
  AxleSpacingField,
  AxleTypeField,
  AxleWeightField,
  AxleWidthField,
  IsSteeringAxleField,
  SuspensionTypeField,
  TireCountField,
  TireRatingField,
  TireSizeField,
} from '@src/permitField/AxleInformationFields';
import type { UseFormSetValue } from 'react-hook-form/dist/types/form';

export const fillAxleInformation = (
  axleIndex: number,
  axleListing: AxleListing,
  //oxlint-disable-next-line
  setValue: UseFormSetValue<any>,
  fieldPrefix: string,
  fields: string[],
) => {
  const fieldMappings = {
    weight: AxleWeightField.fieldName,
    capacity: AxleCapacityField.fieldName,
    width: AxleWidthField.fieldName,
    tireCount: TireCountField.fieldName,
    tireRating: TireRatingField.fieldName,
    tireSize: TireSizeField.fieldName,
    suspensionType: SuspensionTypeField.fieldName,
    group: AxleGroupField.fieldName,
    isSteeringAxle: IsSteeringAxleField.fieldName,
    spacing: AxleSpacingField.fieldName,
    type: AxleTypeField.fieldName,
  };

  if (fields.length > 0) {
    setValue(
      `${fieldPrefix}.${axleIndex}.${AxleIdField.fieldName}`,
      axleListing.id,
    );
  }

  Object.entries(fieldMappings)
    .filter(([_, fieldName]) => fields.includes(fieldName))
    .forEach(([key, fieldName]) => {
      setValue(
        `${fieldPrefix}.${axleIndex}.${fieldName}`,
        axleListing[key as keyof AxleListing],
      );
    });
};
